/*eslint-disable*/
import React from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
// core components
import styles from "assets/jss/material-dashboard-react/components/footerStyle.js";

const useStyles = makeStyles(styles);

export default function Footer(props) {
  const classes = useStyles();
  return (
    <footer className={classes.footer}>
      <div className={classes.container}>
        <div className={classes.left}>
          <List className={classes.list}>
            <ListItem className={classes.inlineBlock}>
              <a href="#home" className={classes.block}>
                صفحه اصلی
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href="/rtl/website" className={classes.block}>
                مشاهده سایت
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href="/rtl/settings" className={classes.block}>
                تنظیمات
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href="/rtl/poststable" className={classes.block}>
                بلاگ
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a href="/login" className={classes.block} style={{color:"red"}} onClick={()=>{localStorage.removeItem('token')}}>
                خروج از حساب
              </a>
            </ListItem>
          </List>
        </div>
        <p className={classes.right}>
          <span>
            &copy; {1900 + new Date().getYear()}{" "}
            <a
              href="/"
              target="_blank"
              className={classes.a}
            >
              riyal company
            </a>
          
          </span>
        </p>
      </div>
    </footer>
  );
}
